import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from 'state/store';

import { ActiveDefectLayer, ActiveDefectLayerId } from './activeLayersSlice';

const selectActiveLayersState = (state: RootState) => state.surveyDataManagerActiveLayers;
const selectUiState = (state: RootState) => state.surveyDataManagerUi;

export const selectActiveDefectLayers = createSelector(
  selectActiveLayersState,
  (slice): readonly ActiveDefectLayer[] => slice.order.map((id) => slice.byId[id]).filter(Boolean),
);

export const selectActiveDefectLayerCount = createSelector(
  selectActiveLayersState,
  (slice): number => slice.order.length,
);

export const selectActiveModal = (state: RootState) => selectUiState(state).activeModal;
export const selectSelectedLayerId = (state: RootState) => selectUiState(state).selectedLayerId;
export const selectExpandedLayerId = (state: RootState) => selectUiState(state).expandedLayerId;
export const selectAdvancedSettingsLayerId = (state: RootState) =>
  selectUiState(state).advancedSettingsLayerId;
export const selectPendingMapLayerIds = (state: RootState): readonly ActiveDefectLayerId[] =>
  selectUiState(state).pendingMapLayerIds;
export const selectPendingMapLayerId = (state: RootState): ActiveDefectLayerId | null =>
  selectUiState(state).pendingMapLayerIds[0] ?? null;
export const selectIsLayerPendingMapRender = (state: RootState): boolean =>
  selectUiState(state).pendingMapLayerIds.length > 0;
export const selectLayerActivation = (state: RootState) =>
  selectUiState(state).layerActivation;
/**
 * True only while a wizard/recipe activation dispatch is in flight
 * Map render pending must not freeze other UI ops
 */
export const selectIsActivatingLayers = (state: RootState): boolean =>
  selectUiState(state).layerActivation.status === 'pending';
